var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Checks and returns outcome of field actions the given field is dependent on
 * @param {Array} fieldActions - Actions the field is depending on
 * @param {Object} values - The current values in form
 */
export var checkFieldActions = function (fieldActions, values) {
    var actions = {};
    if (fieldActions && fieldActions.length > 0) {
        var allActionOutcomes_1 = {
            required: [],
        };
        fieldActions.forEach(function (action) {
            var fieldId = "__field_" + action.field;
            switch (action.thenAction) {
                case 'Hem.Features.Forms.Validators.IsRequiredValidator':
                    var operatorResult = checkOperator(action.operator, values[fieldId], action.whenValue);
                    allActionOutcomes_1.required.push(operatorResult);
                    break;
                default:
                    break;
            }
        });
        Object.keys(allActionOutcomes_1).forEach(function (attribute) {
            var _a, _b;
            if (allActionOutcomes_1[attribute].includes(false)) {
                actions = __assign(__assign({}, actions), (_a = {}, _a[attribute] = false, _a));
            }
            else {
                actions = __assign(__assign({}, actions), (_b = {}, _b[attribute] = true, _b));
            }
        });
    }
    return actions;
};
/**
 * Checks the outcome of an operator
 * @param {String} operator - equal
 * @param {String/Number} dependencyField - Value of the field the action is connected to
 * @param {String} compareValue - Value to compare against/expected value
 */
var checkOperator = function (operator, dependencyField, compareValue) {
    switch (operator) {
        case 'equal':
            return dependencyField === compareValue;
        default:
            break;
    }
};
